/**
 * API URL Builder
 *
 * Explicit API versioning - v1, v2, v3 run simultaneously.
 * Each service declares which version it uses.
 */

import { getApiBaseUrl } from '@/config/environment';

export type ApiVersion = 'v1' | 'v2' | 'v3';

/**
 * Build API URL with explicit version
 *
 * @param path - API endpoint path (e.g., '/admin/users')
 * @param version - API version ('v1', 'v2', 'v3')
 * @returns Full API URL
 *
 * @example
 * buildApiUrl('/admin/drivers', 'v1')
 * // => 'https://api.polarride.com/api/v1/admin/drivers'
 */
export const buildApiUrl = (path: string, version: ApiVersion): string => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${getApiBaseUrl()}/api/${version}${cleanPath}`;
};
